import {
  getEarningRulesWithType,
  deleteEarningRules,
} from '../services/EarningRuleHelper';
import { assembleCouponTemplates } from './CouponUtil';
import { EarningRuleType, EarningRuleRewardType } from '../config/CustomEnums';
import { apiWithResponseHandle, loading } from './LoadingUtil';
import { convertCursorToNumber, convertNumberToCursor, delay } from '../utils';
import { getDisplayDate } from '../utils/TimeFormatUtil';
const getInitialState = () => ({
  earningRuleList: [],
  earningRuleTypeList: [],
  pageInfo: {
    startCursor: '',
    endCursor: '',
    hasNextPage: false,
    hasPreviousPage: false,
  },
  currentLastCursor: '',
  currentPage: 0,
  totalPage: 0,
  totalCount: 0,
  checkedEarningRules: [],
  checkedList: [],
  listDisplayFields: [
    { displayName: 'ID', fieldName: 'pk' },
    { displayName: 'Name', fieldName: 'name', orderField: 'name'},
    { displayName: 'Linked Campaign', fieldName: 'linkedCampaign' },
    { displayName: 'Reward Type', fieldName: 'rewardType' },
    { displayName: 'Create at', fieldName: 'displayCreated', orderField: "creationDate" },
    { displayName: 'Last Modified', fieldName: 'displayModified', orderField: "lastModifiedDate" },
  ],
});

const assembleEarningRules = (earningRules) =>
  earningRules.map((earningRule) => {
    const ruleNode = earningRule.node;
    const type = ruleNode.type;
    const couponTemplateData = {};
    switch (type) {
      case EarningRuleType.generalPurchase:
        couponTemplateData.node =
          ruleNode.generalPurchaseTypeCouponRewardTypeCouponTemplate;
        break;
      case EarningRuleType.memberReferral:
        couponTemplateData.node =
          ruleNode.memberReferralTypeCouponRewardTypeCouponTemplate;
        break;
      case EarningRuleType.newMember:
        couponTemplateData.node =
          ruleNode.newMemberTypeCouponRewardTypeCouponTemplate;
        break;
      case EarningRuleType.birthday:
        couponTemplateData.node =
          ruleNode.birthdayTypeCouponRewardTypeCouponTemplate;
        break;
      case EarningRuleType.qrCodeScanning:
        couponTemplateData.node =
          ruleNode.qrCodeScanningTypeCouponRewardTypeCouponTemplate;
        break;
      case EarningRuleType.gpsCheckIn:
        couponTemplateData.node =
          ruleNode.gpsCheckInTypeCouponRewardTypeCouponTemplate;
        break;
      case EarningRuleType.fillingForm:
        couponTemplateData.node =
          ruleNode.fillingFormTypeCouponRewardTypeCouponTemplate;
          break;
      default:
        break;
    }

    const templates = [];
    if (couponTemplateData.node) {
      templates.push(couponTemplateData);
    }
    return {
      id: ruleNode.id,
      name: ruleNode.name,
      pk: ruleNode.pk,
      couponTemplate: assembleCouponTemplates(templates)[0] || {},
    };
  });

const getKeyByValue = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

const getRewardType = (earnRule) => {
  const key = getKeyByValue(EarningRuleType, earnRule.type);
  const rewardType = earnRule[`${key}TypeRewardType`];

  if (rewardType == EarningRuleRewardType.points) {
    if (earnRule.type === EarningRuleType.generalPurchase) {
      const point =
        earnRule.generalPurchaseTypePointsRewardTypePointsPerXDollarsSpent;
      const x = earnRule.generalPurchaseTypePointsRewardTypeX;
      return `${rewardType}\r\n${x}hours = ${point}pts`;
    }
    const rewardPointValue = earnRule[`${key}TypePointsRewardTypePoints`];
    return `${rewardType}\r\n${rewardPointValue}pts`;
  } else if (rewardType == 'COUPON') {
    const rewardCouponTemplate =
      earnRule[`${key}TypeCouponRewardTypeCouponTemplate`]?.['name'];

    return `${rewardType}: ${rewardCouponTemplate}`;
  }

  return `${rewardType}`;
};

const getLinkedCampaign = (earnRule) => {
  const campaigns = earnRule.campaigns.edges;
  let linkedCampaign = [];
  campaigns.map((campaign) => {
    linkedCampaign.push(campaign.node.name);
  });

  return linkedCampaign.join(', ');
};

const parseEarningRule = (item) => {
  return {
    ...item,
    linkedCampaign: getLinkedCampaign(item),
    rewardType: getRewardType(item),
    displayCreated: getDisplayDate(item.creationDate),
    displayModified: getDisplayDate(item.lastModifiedDate),
  };
};

export default {
  namespace: 'earningRuleList',
  state: getInitialState(),
  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },

    assembleEarningRuleList(state, { payload }) {
      const { templateList, page } = payload;
      const earningRuleList = assembleEarningRules(templateList.edges);
      return {
        ...state,
        earningRuleList:
          page > 1
            ? [...state.earningRuleList, ...earningRuleList]
            : earningRuleList,
      };
    },

    clearData(state, { payload }) {
      return { ...state, ...getInitialState() };
    },
  },

  effects: {
    getEarningRuleListWithTypes: [
      function* ({ payload }, { call, all, put }) {
        const page = payload.page;
        const pageCursor = payload.page
          ? convertNumberToCursor((page - 1) * 20 - 1)
          : '';
        const serviceArgs = [
          getEarningRulesWithType,
          pageCursor,
          payload.reverse,
          payload.type || 'all',
          payload.search,
          payload,
        ];
        function* onSuccess(data) {
          console.log('@@115: ', data);
          const pageInfo = data?.earningRules?.pageInfo;

          const currentLastCursor = pageInfo?.endCursor;
          const totalCount = data?.earningRules?.totalCount;
          yield all([
            put({
              type: 'updateState',
              payload: {
                earningRuleTypeList: data?.earningRules?.edges.map((item) =>
                  parseEarningRule(item.node),
                ),
                pageInfo: {
                  startCursor: convertCursorToNumber(pageInfo.startCursor) + 1,
                  endCursor: convertCursorToNumber(pageInfo.endCursor) + 1,
                },
                currentLastCursor,
                totalCount,
                totalPage: Math.ceil(totalCount / 20),
              },
            }),
            put({
              type: 'assembleEarningRuleList',
              payload: { templateList: data?.earningRules, page: page },
            }),
          ]);
        }
        function* onFailed(data) {
          console.log('@@122: ', data);
        }

        yield loading(serviceArgs, onSuccess, onFailed);
      },
      { type: 'takeLatest' },
    ],
    delete: [
      function* ({ payload }, { select, put, all }) {
        const { checkedEarningRules } = yield select((state) => ({
          checkedEarningRules: state.earningRuleList.checkedList,
        }));

        let pks = [];
        let deleteCampaignIds = [];
        checkedEarningRules.forEach((item) => {
          pks.push(item.pk);

          item.campaigns.edges.forEach((campaign) => {
            deleteCampaignIds.push(campaign.node.pk);
          });
        });

        const serviceArgs = [deleteEarningRules, pks];
        const afterAction = payload.afterAction || (() => {});
        function* onSuccess(data) {
          console.log('@@153: ', data);
          yield all([
            // yield put({
            //   type: 'createCampaign/deleteCampaigns',
            //   payload: { campaignPks: deleteCampaignIds },
            // }),
            // yield put({
            //   type: 'deleteCampaignTranslations',
            //   payload: { campaignPks: deleteCampaignIds },
            // }),
            put({
              type: 'earningRuleList/updateState',
              payload: { checkedList: [] },
            }),
          ]);
          yield delay(1000);
          afterAction();
        }

        yield apiWithResponseHandle(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
  },
};
